export default __webpack_public_path__ + "static/media/blog-driveway-cost-004.0e3b71d1.jpg";